<ng-container *cignaResponsive="let screen">
  <header
    *ngIf="(!modal.options?.static && close !== null) || title"
    class="cml-title"
  >
    <div
      *ngIf="!modal.options?.static && close !== null"
      class="cml-title-controls"
    >
      <button
        cignaButton="link inline no-underline"
        class="cml-btn-close"
        data-test-id="btnClose"
        (click)="closeClick($event)"
      >
        <span *ngIf="!screen.isSmallerOrEqual('sm')">{{ close }}</span>
        <cigna-icon
          class="cml-close-icon"
          type="close-thin"
          aria-label="cancel"
        ></cigna-icon>
      </button>
    </div>

    <h2
      *ngIf="title; else titleTemplate?.templateRef"
      [attr.id]="modal.labelledBy"
      class="cml-heading"
      data-test-id="header-title"
    >
      {{ title }}
    </h2>

    <div *ngIf="subTitle; else subTitleTemplate?.templateRef">
      {{ subTitle }}
    </div>
  </header>

  <div
    #modalContent
    class="cml-content"
    data-test-id="modal-content"
    [attr.id]="modal.describedBy"
    tabindex="-1"
    cignaScrollable
  >
    <div class="cml-content-body">
      <ng-content></ng-content>
    </div>
  </div>

  <footer class="cml-controls-container" *ngIf="hasControls">
    <div
      class="cml-controls"
      [class.two-controls]="!buttonsTemplate && ok && alt"
    >
      <ng-container *ngIf="!buttonsTemplate; else buttonsTemplate">
        <cigna-modal-layout-control
          *ngIf="ok"
          [class.button-stretch]="screen.isSmallerOrEqual('sm') && !alt"
        >
          <button
            cignaButton="primary {{
              screen.isSmallerOrEqual('sm') ? 'large' : 'medium'
            }}"
            class="footer-button"
            (click)="okClick($event)"
            data-test-id="footer-button-ok"
          >
            {{ ok }}
          </button>
        </cigna-modal-layout-control>

        <cigna-modal-layout-control *ngIf="alt">
          <button
            cignaButton="secondary {{
              screen.isSmallerOrEqual('sm') ? 'large' : 'medium'
            }}"
            class="footer-button"
            (click)="altClick()"
            data-test-id="footer-button-cancel"
          >
            {{ alt }}
          </button>
        </cigna-modal-layout-control>
      </ng-container>
    </div>
  </footer>
</ng-container>
